import * as React from 'react'
import Loader from '../../components/Loader'

export default function AppLoadingPage(): React.ReactElement {
  return <Loader className="m-auto flex" style={{ height: '100vh' }} />
}
